const OFFER_ROUTE_BY_TYPE = {
	2: "OfferPlumbing",
	3: "OfferVMC",
	4: "OfferSimple",
	5: "OfferTechnicalRoom",
	6: "OfferCeiling",
	7: "OfferWalls",
	8: "OfferAutomation",
	9: "OfferFanCoilUnit",
	10: "OfferThermalChannel",
	11: "OfferPDC",
	12: "OfferVacuum",
	13: "OfferServices",
	20: "OfferIPA",
};

export function getOfferNavigationParams(offer) {
	const clientId = offer.client?.id ?? offer.client;
	const locationId =
		offer.location?.id ?? offer.location_data?.id ?? offer.location;

	return {
		clientId,
		locationId,
		offerId: offer.id,
	};
}

export function navigateToOffer(router, offer) {
	const params = getOfferNavigationParams(offer);

	if (params.clientId) {
		sessionStorage.setItem("clientId", String(params.clientId));
	}

	const routeName = OFFER_ROUTE_BY_TYPE[offer.type];

	if (routeName) {
		router.push({
			name: routeName,
			params,
		});
		return;
	}

	window.open(
		process.env.VUE_APP_API_BASE_URL + `/app/oferta/detaliu/${offer.id}`,
		"_blank"
	);
}
